import { B300, G300, P300, R300, T300, Y300 } from '@atlaskit/theme/colors';

const COLORS = [G300, Y300, R300, B300, P300, T300];

export const getColor = (index: number): string => COLORS[index % COLORS.length];
